import moment from "moment";

import {
  Badge,
  CopyButton,
  OverflowMenuDropDown,
  OverflowMenuDropDownItem,
} from "../../components";
import { appConfig } from "../../configs";
import {
  IViewTeamMember,
  StatusColors,
  // StatusColors,
} from "../../interfaces-and-types";
import {
  getTeamMemberStatusIndicator,
  // getTeamMemberStatusIndicator,
  truncateStringWithEllipsis,
} from "../../utils";
import { teamMemberStatus } from "../../enums";

export const teamAndSecurityDisplayFormatter = (item: IViewTeamMember) => {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    getTeamMemberStatusIndicator(item);

  return {
    ...item,
    full_name: item.full_name || "...",
    email: (
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={item.email}>
            {truncateStringWithEllipsis(item.email, 35)}
          </span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            name="copy-reference-button"
            stringToCopy={item.email}
            iconDescription="copy team member email"
            className="copy-btn"
          />
        </div>
      </div>
    ),
    status: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    user_access_claims: (
      <div className="claims-container flex-container justify-content--start align-items--center no-wrap">
        {item.user_access_claims.map((claim) => (
          <Badge
            statusColor={
              claim.toLowerCase().includes("owner")
                ? "teal"
                : claim.toLowerCase().includes("admin")
                ? "primary"
                : "warning"
            }
            hideIndicator
            text={claim}
            className={`mr-5 ${
              item.user_access_claims.length >= 3 ? "mb-5" : ""
            }`}
          />
        ))}
      </div>
    ),
    created_at: (
      <span className="date--oneline">
        {item.created_at
          ? moment(item.created_at).format(appConfig.dateTimeFormat)
          : "..."}
      </span>
    ),
    more: (
      <OverflowMenuDropDown
        focusTrap={true}
        data-floating-menu-container
        size="sm"
        flipped
      >
        {item.status === teamMemberStatus.pending ? null : (
          <OverflowMenuDropDownItem
            index={1}
            itemText="Manage User Access"
            onClick={item.openEditModal}
          />
        )}
        {item.status !== teamMemberStatus.pending ? null : (
          <OverflowMenuDropDownItem
            index={2}
            itemText="Resend Invitation Link"
            onClick={item.resendInvitationLink}
          />
        )}
        <OverflowMenuDropDownItem
          index={3}
          // hasDivider={item.status === paymentLinkStatus.deactivated}
          isDelete
          itemText={
            item.status === teamMemberStatus.pending
              ? "Delete Invitation"
              : item.status === teamMemberStatus.disabled
              ? "Enable Team Member"
              : "Disable Team Member"
          }
          onClick={item.openDeleteModal}
        />
      </OverflowMenuDropDown>
    ),
  };
};
